import * as Yup from 'yup';
const validationSchema = Yup.object().shape({
	

});
const Inputs = [
	{
		name: 'translations',
		label: 'Translations',
		type: 'nestedArray',
		value: 'multiple',
		valueAttr: 'translations',
		columns: [
			{
				name: 'languageCode',
				label: 'Language',
				type: 'text',
				required: true,
			},
			{
				name: 'translatedName',
				label: 'Translated Name',
				type: 'text',
				required: true,
			}
		]
	}

];

export { Inputs, validationSchema };
